import React,{ Fragment, useState } from "react";
import {
  Card,
  CardBody
} from "reactstrap";
import CommonDataTable from "../../../share-components/table/commonDataTable";
import PreLoader from "../../../share-components/ui/preLoader";
import BackInStockTable from "../../backInStock/content/backInStockTable";

const MismatchStatus = ({ value }) => {
  const isMismatch = Boolean(value);

  return (
    <span
      style={{
        color: isMismatch ? "#dc0000" : "#139a35",
        fontWeight: 600,
      }}
    >
      {isMismatch ? "Mismatch" : "No Mismatch"}
    </span>
  );
};

const ChildMimatchStatus = ({ partnerName, partnerVal, isPrice = false }) => {
  return (
    <div>
      <p className="mb-0">
        Goddiva : <span>--</span>
      </p>
      <p style={{ fontWeight: 600, marginTop: 0 }}>
        {partnerName} : <span>{isPrice ? `£ ${Number(partnerVal).toFixed(2)}` : `${partnerVal}`}</span>
      </p>
    </div>
  );
};

const statusValue = {
  1: "badge-primary",
  2: "badge-success",
  3: "badge-warning",
};

function OrdersNotFound({ partnerState, page, setPage, pageSize, setPageSize, unMatchLoading }) {
  const [activeTab, setActiveTab] = useState("1");
  const [isChecked, setIsChecked] = useState(null);
  const [itemIdArray, setItemIdArray] = useState([]);
  const [orderCheckBoxData, setOrderCheckBoxData] = useState({ idArray: [] });

  const tableColumns = [
    {
      name: "Order ID",
      selector: (row) => {
        return (
          <div>
            <p className="mb-0">
              Goddiva : <span>--</span>
            </p>
            <p className="mt-0" style={{ fontWeight: 600 }}>
              {row.partner_name} : <span>{row.order_no}</span>
            </p>
          </div>
        );
      },
      sortable: true,
      center: false,
    },
    {
      name: "MP Order ID",
      selector: (row) => row.mp_order_number,
      sortable: true,
      center: false,
    },
    {
      name: "Order Date",
      selector: (row) => row.order_date,
      sortable: true,
      center: false,
    },
    {
      name: "Payout Date",
      selector: (row) => row.dispatch_date,
      sortable: true,
      center: false,
    },
    {
      name: "SKU",
      selector: (row) => {
        return row.sku ?? "-";
      },
      sortable: true,
      center: false,
    },
    {
      name: "Price",
      selector: (row) => {
        return row.price ?? "-";
      },
      sortable: true,
      center: false,
    },
    {
      name: "Qty",
      selector: (row) => {
        return row.quantity ?? "-";
      },
      sortable: true,
      center: false,
    },
    {
      name: "Status",
      selector: (row) => (
        <div className="py-1">
          <p
            style={{
              color: "#dc0000",
              fontWeight: 500,
              marginBottom: 1,
              marginTop: 1,
            }}
          >
            Order Not Found
          </p>
        </div>
      ),
      sortable: true,
      left: true,
      width: "200px",
    },
    {
      name: "Action Status",
      selector: (row) => row.action_status,
      cell: (row) => (
        <div>
          <span className={`badge px-3 badge-primary`}>Pending</span>
        </div>
      ),
      width: "200px",
      sortable: true,
      center: true,
    },
  ];

  const ExpandedComponent = ({ data }) => {
    console.log("DATAAAA", data);
    const childData = data.items;
    const partnerName = data.partner_name;

    const childTableColumns = [
      {
        name: "SKU",
        selector: (row) => <ChildMimatchStatus partnerName={partnerName} godVal={row.sku} partnerVal={row.sku} />,
        sortable: false,
        center: false,
      },
      {
        name: "Price",
        selector: (row) => <ChildMimatchStatus partnerName={partnerName} godVal={row.price} partnerVal={row.price} isPrice={true} />,
        sortable: false,
        center: false,
      },
      {
        name: "Qty",
        selector: (row) => <ChildMimatchStatus partnerName={partnerName} godVal={row.quantity} partnerVal={row.quantity} />,
        sortable: false,
        center: false,
      },
      {
        name: "Status",
        selector: (row) => (
          <div className="py-1">
            <p
              style={{
                color: "#dc0000",
                fontWeight: 500,
                marginBottom: 1,
                marginTop: 1,
              }}
            >
              Item Not Found
            </p>
          </div>
        ),
        sortable: false,
        left: true,
        width: "200px",
      },
    ];

    return (
      <div className="px-5 pt-3 pb-5 border-bottom">
        <CommonDataTable headerColumns={childTableColumns} data={childData} noAction pagination={false} />
      </div>
    );
  };

  const handleChange = (state) => {
    const selectedIDs = state.selectedRows.map((row) => row.id);

    setOrderCheckBoxData({ idArray: selectedIDs });
    setItemIdArray(selectedIDs);
    setIsChecked(selectedIDs.length > 0);
  };

  const pageChange = (e) => {
    setPage(e);
  };
  const onPageSizeChange = (e) => {
    setPage(1);
    setPageSize(e);
  };

  return (
    <Fragment>
      <Card className="mt-4 ribbon-wrapper">
        <CardBody>
          <div className="ribbon ribbon-clip ribbon-dark h6">Orders Not Found in Our Marketplace</div>

          {unMatchLoading ? (
            <div style={{ minHeight: 400 }}>
              <PreLoader />
            </div>
          ) : (
            <div className="table-responsive product-table">
              {/* <BackInStockTable
                // toggleRowSelected={toggleRowSelected}
                paginationTotalRows={partnerState.unMatchedTableRow}
                idArray={orderCheckBoxData}
                tableColumns={tableColumns}
                backStockData={partnerState.unMatchedData || []}
                backInRequestState={partnerState}
                pageChange={pageChange}
                onPageSizeChange={onPageSizeChange}
                
                handleChange={handleChange}
                paginationRowsPerPageOptions={[10, 25, 50, 100]}
                paginationDefaultPage={page}
                paginationPerPage={pageSize}
                expandableRows
                expandableRowsComponent={ExpandedComponent}
              /> */}
              <CommonDataTable
                headerColumns={tableColumns}
                gridData={partnerState.unMatchedData || []}
                paginationServer
                paginationTotalRows={partnerState.unMatchedTableRow}
                onChangePage={pageChange}
                onChangeRowsPerPage={onPageSizeChange}
                paginationRowsPerPageOptions={[10, 25, 50, 100]}

                noAction
                paginationDefaultPage={page}
                paginationPerPage={pageSize}
                expandableRows
                expandableRowsComponent={ExpandedComponent}
              />
            </div>
          )}
        </CardBody>
      </Card>
    </Fragment>
  );
}

export default OrdersNotFound;
